export default "__VITE_ASSET__a2fb3608__"